/**
Author - Venkatesh Pullaganti😃
Git - https://github.com/venkatesh1146
**/

import {AA_CONSENT_STATUS, AA_PROCESSING_STATUS} from 'constants/AAConstants';

export const shouldStartPolling = (consentStatus, processingStatus) => {
  if (consentStatus === AA_CONSENT_STATUS.PENDING) {
    return true;
  }

  if (
    consentStatus === AA_CONSENT_STATUS.ACTIVE &&
    (processingStatus === AA_PROCESSING_STATUS.FETCHING ||
      processingStatus === AA_PROCESSING_STATUS.PROCESSING)
  ) {
    return true;
  }

  return false;
};

export const shouldShowRetryOption = (consentStatus) => {
  return consentStatus === AA_CONSENT_STATUS.EXPIRED;
};

export const isConsentComplete = (processingStatus) => {
  return processingStatus === AA_PROCESSING_STATUS.PROCESSED;
};

export const isConsentFailed = (consentStatus, processingStatus) => {
  return (
    [AA_CONSENT_STATUS.REJECTED, AA_CONSENT_STATUS.EXPIRED, AA_CONSENT_STATUS.REVOKED].includes(
      consentStatus
    ) || processingStatus === AA_PROCESSING_STATUS.FAILED
  );
};

export const isAnalysisFailed = (consentStatus, processingStatus, errorMessage) => {
  return (
    consentStatus === AA_CONSENT_STATUS.ACTIVE &&
    processingStatus === AA_PROCESSING_STATUS.PROCESSED &&
    errorMessage
  );
};
